<template><section><h3>基于PB级数据的人机协同科学发现系统</h3>
<h4>背景介绍：</h4>
<p>黑潮是一种特殊的海洋现象，其具有流速较强、路径不稳定的特征。黑潮延伸区域指黑潮离开日本海岸后进入北太平洋的开阔水域，该区域的海表温度锋面效应强、海洋-大气相互作用强等特征，对于区域气候变化、海洋生态系统及天气预报等应用领域具有重要意义。假设驱动的黑潮延伸区域可视分析系统，目的是实现黑潮延伸区域的中尺度海洋-大气相互作用的证据收集与可视化呈现并为用户提供合理的分析结论。该软件设置5个界面，分别为：全球可视化界面、合成分析界面、跨界面流场可视化界面、证据矩阵界面和智能体界面。具有四大功能，分别为：全球海温场背景下的黑潮路径与涡旋可视化、面向海洋-大气相互作用的多要素涡旋合成分析、海洋涡旋与近海面风场的流带可视化、假设验证与智能问答。</p>
<p>然而，现有的假设驱动的黑潮延伸区域可视分析系统在并行可扩展性等方面存在性能问题，需要进行优化。目前的实现仅针对选定的空间与时间段进行MB级数据集的后处理分析，未能实现PB级数据集的处理。本项目针对PB级数据集数据集开发并行与增量式计算方法，并将工作流程拓展至更长时段、更多变量以及其它海洋中的锋面区域。</p>
<h4>项目要求：</h4>
<ol>
<li>
<p>数据预处理层的并行化与增量计算</p>
<ul>
<li>选取项目内一类典型预处理任务(例如:涡旋识别合成、锋面栅格化、海表温度场重采样、长时间序列滑动窗口统计等),从单线程基线实现改造为基于多线程/GPU/多进程的并行方案。</li>
<li>引入增量计算:数据按瓦片或时间段分块,仅对新增/变化的块触发计算,避免全量重算。</li>
<li>至少在一个真实 PB 级数据集上完成对比实验,记录加速比、内存峰值、I/O 耗时等关键指标。</li>
</ul>
</li>
<li>
<p>可视化渲染的并行化</p>
<ul>
<li>评估现有全球海温场背景、合成分析、流带等可视化的主线程开销瓶颈(WebGL/Canvas/DOM 等),将耗时计算(例如:栅格重投影、流线积分、纹理上传)迁移到 Web Worker / 共享内存 / OffscreenCanvas 等并行通道。</li>
<li>实现&quot;数据加载 → 渲染&quot;流水线,使用户在交互过程中观察不到长时间的渲染阻塞。</li>
<li>给出在同一视图中&quot;开并行&quot;前后帧时间与交互延迟的对比曲线。</li>
</ul>
</li>
<li>
<p>AI 分析调度的并行化与可观察性</p>
<ul>
<li>围绕证据矩阵、智能体问答两个 AI 入口,把&quot;假设-证据匹配&quot;分解为可独立调度的子任务,并通过任务队列并行化多个假设/多组证据片段的检索与对齐。</li>
<li>提供 AI 调度的可视化面板:正在运行的子任务、排队中的子任务、已完成/失败状态一目了然。</li>
</ul>
</li>
<li>
<p>交互响应的并行化与体验优化</p>
<ul>
<li>在选区、刷选、时间轴拖动、跨界面同步等高频交互路径上,把可视化副作用与耗时计算解耦,确保拖动过程中视口维持至少24FPS 的目标。</li>
<li>在交互层建立&quot;操作日志 + 性能指标&quot;埋点,作为后续性能调优的依据。</li>
</ul>
</li>
</ol>
</section></template><script>export default {components:{}}</script>